<template>
  <main>
    <section class="container">
      <div class="row">
        <div class="col">
          <h2>{{title}}</h2>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  data () {
    return {
      title: 'JS特訓班'
    }
  }
}
</script>
